import React from 'react'
import { useNavigate } from 'react-router-dom'
import next from '../../Assests/next.png'
export default function ProjectCard({ project }) {
    const navigate = useNavigate();
    const handleClick = id => {
        navigate(`/${id}`);
    }
    return (
        <div className=' mt-4 border bg-slate-500 rounded-lg duration-500'>
            <div className=''>
                <div className=' overflow-hidden relative scrol'>
                    <img src={project.img[0]} alt="" className='w-full ' />
                    <div className='py-4  bottom-0  hover:cursor-pointer w-full duration-200 z-10 '>
                        <div className='flex justify-center items-center duration-200'>
                            <h1 className='text-white drop-shadow font-bold h-auto transition duration-100  text-xl my-2 text-center' >{project.name}</h1>
                            {/* <img onClick={() => handleClick(project._id)} src={next} alt="" className='w-8 h-8 hover:shadow-lg hover:animate-none translate-x-2 md:translate-x-12 rounded-full shadow-green-500' /> */}
                        </div>
                        <div className=' flex justify-center mb-4'>
                            <button onClick={() => handleClick(project._id)} className='border px-6 rounded-3xl font-bold uppercase text-white py-2 text-center shadow-sm hover:text-green-500 shadow-white'>Details</button>
                        </div>
                        <div className='flex gap-2 justify-center flex-wrap'>
                            {
                                project?.tech.map((tech, index) => <p className='border rounded-lg shadow-lg shadow-white  p-2 text-xs text-green-500 uppercase font-bold' key={index}>
                                    {tech}
                                </p>)
                            }
                        </div>
                    </div>
                </div>
                {/* <h3>{project.name}</h3> */}
            </div>
        </div>
    )
}
